import PropTypes from 'prop-types';

import { TierPricesPropTypes } from '@/common/proptypes/PricesAndStocks/Price/TierPrices/TierPrices.proptypes';

export const ByTypeDefaultProps = {}; // If needed

export const ByTypeProTypes = {
  ...TierPricesPropTypes,
  customer_price: PropTypes.number,
  discount_price: PropTypes.number,
  public_price: PropTypes.number,
  unit: PropTypes.string,
  weee_amount: PropTypes.number,
};
